import React, { useState } from 'react';
import { Chip, Tooltip, Button, Stack, CircularProgress } from '@mui/material';
import { resendVerificationApi } from '../api/auth';
import { useAuth } from '../context/AuthContext';

const StatusBadge = () => {
  const { user, refreshUser } = useAuth();
  const [loading, setLoading] = useState(false);

  if (!user) return null;

  const isVerified = Boolean(user.emailVerified);
  const isApproved = user.approvalStatus === 'approved';

  const resend = async () => {
    setLoading(true);
    try {
      await resendVerificationApi({ email: user.email });
    } catch (_) {
      // ignore
    } finally {
      setLoading(false);
    }
  };

  const refresh = async () => {
    setLoading(true);
    await refreshUser();
    setLoading(false);
  };

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <Tooltip title={isVerified ? 'Email verified' : 'Email not verified'}>
        <Chip size="small" color={isVerified ? 'success' : 'warning'} label={isVerified ? 'Verified' : 'Unverified'} />
      </Tooltip>
      <Tooltip title={isApproved ? 'Account approved' : 'Awaiting superadmin approval'}>
        <Chip size="small" color={isApproved ? 'success' : 'warning'} label={isApproved ? 'Approved' : 'Pending approval'} />
      </Tooltip>
      {!isVerified && (
        <Button size="small" variant="outlined" onClick={resend} disabled={loading}>
          {loading ? <CircularProgress size={14} /> : 'Resend link'}
        </Button>
      )}
      <Button size="small" variant="text" onClick={refresh} disabled={loading}>
        {loading ? <CircularProgress size={14} /> : 'Refresh'}
      </Button>
    </Stack>
  );
};

export default StatusBadge;


